// generated by genversion
export var version = '4.5.10';
//# sourceMappingURL=version.js.map